import {TabState, TabStateDefaults} from 'Navigation';

export default class StudyListingTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Study items',
      closeable: false,
      preferenceKey: 'study-listing',
    };
  }
}
